__turbopack_context__.v({
  "input": "calculatorInputWithRadio-module-scss-module__tlDnWG__input",
  "radioRow": "calculatorInputWithRadio-module-scss-module__tlDnWG__radioRow",
  "title": "calculatorInputWithRadio-module-scss-module__tlDnWG__title",
  "wrap": "calculatorInputWithRadio-module-scss-module__tlDnWG__wrap",
});
